import {createFileRoute} from '@tanstack/react-router';

import {CompanyLayout} from '@/features/User/components/Company/CompanyLayout';

export const Route = createFileRoute('/_b/_p/_company')({
  component: CompanyLayout,
});
